import styled, {css} from 'styled-components'

export const CardGrid = styled.div<{compact?: boolean}>(
  ({compact}) => css`
    display: grid;
    gap: ${compact ? 1.5 : 2}rem;
    grid-template-columns: repeat(auto-fill, minmax(${compact ? 10.5 : 14}rem, 1fr));
  `
)
